import { useLocation } from 'react-router-dom';
import React, { useMemo, useState } from 'react';
import Container from '@mui/material/Container';
import { Box } from '@mui/material';
import { useSelector } from 'react-redux';
import CustomHeader from '../../../General/CustomHeader';
import Page from '../../../Layout/Page';
import FullScreenChartShell from '../../FullScreenChartShell/FullScreenChartShell';
import useStyles from '../../styles';
import SoilMoistureChart from './SoilMoistureChart';
import SoilMoistureConfigContent, { EMPTY_MODAL_STATE, ModalState } from './SoilMoistureConfigContent';
import { SOIL_MOISTURE_NAME } from '../../../../constants/graphs';
import { ReduxState } from '../../../../types';
import { generateBreadcrumb } from '../../utils';

const SoilMoisture = ({ fullScreen }: { fullScreen?: boolean }) => {
  const classes = useStyles();
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);

  const { selectedFarm } = useSelector((state: ReduxState) => state.accountFarm);
  const selectedSector = useSelector((state: ReduxState) => state.currentSector.selectedSector);

  const [modalState, setModalState] = useState<ModalState>(EMPTY_MODAL_STATE);
  const [conversationsRefreshCounter, setConversationsRefreshCounter] = useState(0);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const params = {
    farmId: queryParams.get('farmId') || '',
    sectorId: queryParams.get('sectorId') || '',
  };

  const breadcrumb = useMemo(() => generateBreadcrumb(
    selectedFarm, selectedSector, SOIL_MOISTURE_NAME, params.sectorId,
  ), [selectedFarm, selectedSector]);

  if (fullScreen) {
    return (
      <FullScreenChartShell title="Humedad de Suelo">
        {(h) => (
          <SoilMoistureChart
            chartView="fullScreen"
            sectorId={params.sectorId}
            farmId={params.farmId}
            externalModalState={modalState}
            externalSetModalState={setModalState}
            hideXValues={false}
            height={`${h}px`}
            onConversationCreated={() => setConversationsRefreshCounter((prev) => prev + 1)}
            refreshCounter={refreshTrigger}
          />
        )}
      </FullScreenChartShell>
    );
  }

  return (
    <Page className={classes.root} title='Humedad suelo'>
      <Container maxWidth={false}>
        <CustomHeader title={breadcrumb} />
        <Box mt={3}>
          <SoilMoistureChart
            chartView="settings"
            sectorId={params.sectorId}
            farmId={params.farmId}
            externalModalState={modalState}
            externalSetModalState={setModalState}
            onConversationCreated={() => setConversationsRefreshCounter((prev) => prev + 1)}
            refreshCounter={refreshTrigger}
          />
        </Box>
        <SoilMoistureConfigContent
          sectorId={params.sectorId}
          setModalState={setModalState}
          refreshCounter={conversationsRefreshCounter}
          onConfigSaved={() => setRefreshTrigger((prev) => prev + 1)}
        />
      </Container>
    </Page>
  );
};

export default SoilMoisture;
